<div *ngIf="loaderStyle === 'material'" class="d-flex justify-content-center align-items-center w-100">
  <mat-spinner></mat-spinner>
</div>

<div *ngIf="loaderStyle === 'custom-tailwind'"
     class="fixed inset-0 flex items-center justify-center bg-gray-900 bg-opacity-50 z-50">
  <div class="animate-spin rounded-full h-16 w-16 border-t-2 border-b-2 border-gray-100">
  </div>
</div>
